// src/components/WhoWeHelp.jsx
import { motion } from "framer-motion";
import { useState, useEffect } from "react";

import logo1 from "../assets/1.jpg";
import logo2 from "../assets/2.jpg";
import logo3 from "../assets/3.jpg";
import logo4 from "../assets/4.jpg";
import logo5 from "../assets/5.jpg";
import logo6 from "../assets/6.jpg";
import logo7 from "../assets/7.jpg";
import logo8 from "../assets/8.jpg";
import logo9 from "../assets/9.jpg";
import logo10 from "../assets/10.jpg";
import logo11 from "../assets/11.jpg";
import logo12 from "../assets/12.jpg";
import logo13 from "../assets/13.jpg";
import logo14 from "../assets/14.jpg";
import logo15 from "../assets/15.jpg";
import logo16 from "../assets/16.jpg";
import logo17 from "../assets/17.jpg";
import logo18 from "../assets/18.jpg";
import logo19 from "../assets/19.jpg";
import logo20 from "../assets/20.jpg";
import logo21 from "../assets/21.jpg";
import logo22 from "../assets/22.jpg";
import logo23 from "../assets/23.jpg";
import logo24 from "../assets/24.jpg";
import logo25 from "../assets/25.jpg";
import logo26 from "../assets/26.jpg";
import logo27 from "../assets/27.jpg";
import logo28 from "../assets/28.jpg";
import logo29 from "../assets/29.jpg";
import logo30 from "../assets/30.jpg";
import logo31 from "../assets/31.jpg";
import logo32 from "../assets/32.jpg";
import logo33 from "../assets/33.jpg";
import logo34 from "../assets/34.jpg";
import logo35 from "../assets/35.jpg";
import logo36 from "../assets/36.jpg";
import logo37 from "../assets/37.jpg";
import logo38 from "../assets/38.jpg";
import logo39 from "../assets/39.jpg";

/* =============================== */
const logos = [
  { name: "Client 1", src: logo1 },
  { name: "Client 2", src: logo2 },
  { name: "Client 3", src: logo3 },
  { name: "Client 4", src: logo4 },
  { name: "Client 5", src: logo5 },
  { name: "Client 6", src: logo6 },
  { name: "Client 7", src: logo7 },
  { name: "Client 8", src: logo8 },
  { name: "Client 9", src: logo9 },
  { name: "Client 10", src: logo10 },
  { name: "Client 11", src: logo11 },
  { name: "Client 12", src: logo12 },
  { name: "Client 13", src: logo13 },
  { name: "Client 14", src: logo14 },
  { name: "Client 15", src: logo15 },
  { name: "Client 16", src: logo16 },
  { name: "Client 17", src: logo17 },
  { name: "Client 18", src: logo18 },
  { name: "Client 19", src: logo19 },
  { name: "Client 20", src: logo20 },
  { name: "Client 21", src: logo21 },
  { name: "Client 22", src: logo22 },
  { name: "Client 23", src: logo23 },
  { name: "Client 24", src: logo24 },
  { name: "Client 25", src: logo25 },
  { name: "Client 26", src: logo26 },
  { name: "Client 27", src: logo27 },
  { name: "Client 28", src: logo28 },
  { name: "Client 29", src: logo29 },
  { name: "Client 30", src: logo30 },
  { name: "Client 31", src: logo31 },
  { name: "Client 32", src: logo32 },
  { name: "Client 33", src: logo33 },
  { name: "Client 34", src: logo34 },
  { name: "Client 35", src: logo35 },
  { name: "Client 36", src: logo36 },
  { name: "Client 37", src: logo37 },
  { name: "Client 38", src: logo38 },
  { name: "Client 39", src: logo39 },
];

export default function WhoWeHelp() {

  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ name: "", email: "", otp: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);

  /* =============================== */
  const downloadChecklist = () => {
    const link = document.createElement("a");
    link.href = "/checklist.pdf";
    link.download = "Operations-Checklist.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  /* =============================== */
  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  /* =============================== */
  const sendOTP = async () => {

    if (!form.name || !form.email) {
      setMessage("⚠️ Please enter name and email");
      return;
    }

    if (!validateEmail(form.email)) {
      setMessage("⚠️ Invalid email format");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("http://localhost:5000/send-otp", {
        method: "POST",
        headers: {"Content-Type":"application/json"},
        body: JSON.stringify({ name: form.name, email: form.email })
      });

      const data = await res.json();

      if(data.success){
        setStep(2);
        setMessage("✅ OTP sent to your email");
        setTimer(60);
      } else {
        setMessage(`❌ ${data.message}`);
      }

    } catch {
      setMessage("❌ Server not running");
    }

    setLoading(false);
  };

  /* =============================== */
  const verifyOTP = async () => {

    if (!form.otp) {
      setMessage("⚠️ Enter OTP");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("http://localhost:5000/verify-otp", {
        method: "POST",
        headers: {"Content-Type":"application/json"},
        body: JSON.stringify({ email: form.email, otp: form.otp })
      });

      const data = await res.json();

      if(data.success){
        setStep(3);
        setMessage("✅ Checklist sent! Check your email.");

        downloadChecklist();

        /* AUTO CLOSE AFTER SUCCESS */
        setTimeout(() => {
          setOpen(false);
          setStep(1);
          setForm({ name: "", email: "", otp: "" });
          setMessage("");
        }, 3000);

      } else {
        setMessage(`❌ ${data.message}`);
      }

    } catch {
      setMessage("❌ Server error");
    }

    setLoading(false);
  };

  return (
    <section className="relative pt-10 md:pt-20 lg:pt-28 pb-20 px-6 bg-neutral-background overflow-hidden">

      <div className="relative z-20 max-w-5xl mx-auto text-center">

        <motion.h3 className="font-heading text-3xl md:text-4xl text-primary mb-6">
          Trusted by Growing Businesses
        </motion.h3>

        <motion.p className="text-neutral-muted text-lg mb-14">
          Supporting founders, service-based companies, and agencies
          with structured operations, marketing systems, and reliable
          virtual assistance.
        </motion.p>

        <motion.h4 className="font-heading text-xl md:text-2xl text-primary mb-6">
          We Don’t Just Provide Virtual Assistants —
          <span className="text-accent"> We Build Executive Support Partnerships</span>
        </motion.h4>

        <motion.div className="space-y-6 text-neutral-muted text-base md:text-lg leading-relaxed">
          <p>
            At <span className="font-semibold text-primary">Rcreate Virtual Assistance Services</span>,
            we match busy founders, CEOs, coaches, and service-based businesses
            with highly capable Virtual Assistants who act like right-hand
            partners — not task workers.
          </p>
          <p>
            Our VAs don’t just complete tasks. They think ahead, solve problems,
            and manage daily execution across operations, admin, communications,
            and marketing — so you can lead, not manage.
          </p>
          <p>
            We work with businesses of all sizes around the world, helping you
            streamline internal processes and strengthen your external presence.
          </p>
        </motion.div>

        <div className="mt-12">
          <button onClick={()=>setOpen(true)}
            className="px-8 py-4 rounded-full bg-accent text-white font-semibold hover:opacity-90 transition">
            Get the Free Checklist
          </button>
        </div>

      </div>

      {open && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl w-full max-w-md">

            <h2 className="text-lg font-bold text-center mb-4">
              Get Your Checklist
            </h2>

            <p className="text-center text-sm mb-4">{message}</p>

            {step === 1 && (
              <>
                <input className="w-full p-3 border mb-3"
                  placeholder="Name"
                  disabled={loading}
                  onKeyDown={(e)=>e.key==="Enter" && sendOTP()}
                  onChange={(e)=>setForm({...form,name:e.target.value})}/>

                <input className="w-full p-3 border mb-3"
                  placeholder="Email"
                  disabled={loading}
                  onKeyDown={(e)=>e.key==="Enter" && sendOTP()}
                  onChange={(e)=>setForm({...form,email:e.target.value})}/>

                <button disabled={loading}
                  onClick={sendOTP}
                  className="w-full bg-accent text-white py-2">
                  {loading ? "Sending..." : "Send OTP"}
                </button>
              </>
            )}

            {step === 2 && (
              <>
                <input className="w-full p-3 border mb-3 text-center"
                  placeholder="OTP"
                  disabled={loading}
                  onKeyDown={(e)=>e.key==="Enter" && verifyOTP()}
                  onChange={(e)=>setForm({...form,otp:e.target.value})}/>

                <button disabled={loading}
                  onClick={verifyOTP}
                  className="w-full bg-accent text-white py-2 mb-2">
                  {loading ? "Verifying..." : "Verify"}
                </button>

                <button disabled={timer > 0}
                  onClick={sendOTP}
                  className="w-full text-sm text-blue-600">
                  {timer > 0 ? `Resend in ${timer}s` : "Resend OTP"}
                </button>
              </>
            )}

            {step === 3 && (
              <p className="text-green-600 text-center">✅ Done</p>
            )}

            <button onClick={()=>setOpen(false)}
              className="mt-4 w-full text-sm">
              Close
            </button>

          </div>
        </div>
      )}

      <div className="relative mt-24 overflow-hidden">
        <motion.div className="flex gap-10 items-center w-max"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ repeat: Infinity, duration: 80, ease: "linear" }}>
          {[...logos, ...logos].map((logo, index) => (
            <img key={index} src={logo.src} className="max-h-14" />
          ))}
        </motion.div>
      </div>

    </section>
  );
}